export default {
    'gps.details': 'Details',
    'gps.date': 'Date',
    'gps.hour': 'Hour',
    'gps.format.name': 'Internal No.',
    'gps.format.registerNumber': 'License Plate ',
    'gps.driver': 'Driver',
    'gps.speed(Km/Hr)': 'Speed (Km/Hr) ',
    'gps.orientation': 'Orientation',
    'gps.coordinates': 'Coordinates',
    'gps.address': 'Address',
    "gps.north": "North",
    "gps.northeast": "North-East",
    "gps.east": "East",
    "gps.southeast": "South-East",
    "gps.south": "South",
    "gps.southwest": "South-West",
    "gps.west": "West",
    "gps.northwest": "North-West",
    "gps.showimage": "Show Image",
    "gps.showvideo": "Show Video",
    "gps.select.parentgroup": "Parent Group",
    "gps.select.group": "Group",
    "gps.select.nameregisternumber": "License No or Internal No",
    "location": "Location",
    "close": "Close",
    "routingmap.osmMap": "Routes Map",
    "routingmap.hybridMap": "Hybrid Map",
    "routingmap.satelliteMap": "Satellite Map",
    "routingmap.googleTerrain": "Terrain Map",
    "routingmap.standardMap": "Standard Map",
    "routingmap.trafficMap": "Traffic Map",
    "routingmap.hybirdtrafficMap": "Hybrid Traffic Map",
    "gps.navigation": "Navigation",
    "loading": "Loading",
    "nooptions": "No Options",
    "routecode": "Code",
    "submit": "Submit",
    "enter_route_code": "Enter code",
    "route_required": "Please enter code",
    "no_data": "No Data",
    "updatePrompt.title": "Updaet Available",
    "updatePrompt.description": "Please click on the update now button to update the app to the latest version",
    "updatePrompt.button": "Update Now",
    "gps.streetview": "Street View",
    "gps.youAreHere": "You are here",
    "gps.distanceToYou": "Distance to you",
    "gps.yourLocation": "Your location",
    "gps.closestVehicle": "Nearest vehicle",
    "gps.geolocationUnsupported": "Geolocation is not supported by this browser.",
    "gps.geolocationError": "Unable to retrieve your location.",
    "gps.travelTime": "Estimated travel time",
    "gps.travelTimeLessMinute": "<1 min",
    "gps.travelTimeMinutes": "{value} min",
    "gps.travelTimeHours": "{value} h",
    "gps.travelTimeHoursMinutes": "{hours} h {minutes} min",
    "monitor.bottomBar.vehicleDetails": "Vehicle Details",
    "monitor.bottomBar.vehiclePlaceholder": "Selected vehicle",
    "monitor.bottomBar.expand": "Show",
    "monitor.bottomBar.collapse": "Hide",
    "monitor.bottomBar.tabs.speed": "Speed",
    "monitor.bottomBar.tabs.batteryVoltage": "Battery Voltage",
    "monitor.bottomBar.tabs.batteryAmperage": "Battery Amperage",
    "monitor.bottomBar.tabs.rpm": "RPM",
    "monitor.bottomBar.tabs.soc": "State of Charge",
    "monitor.bottomBar.noData": "No data available",
    "monitor.bottomBar.updated": "Last update",
    "monitor.bottomBar.latestValue": "Latest value",
    "monitor.bottomBar.noSeriesData": "No chart data available",
    "monitor.bottomBar.historyLoading": "Loading history...",
    "monitor.bottomBar.historyError": "Unable to load historical positions.",
    "monitor.bottomBar.shortHistory.show": "Short History",
    "monitor.bottomBar.shortHistory.hide": "Hide Short History",
    "monitor.bottomBar.shortHistory.timestamp": "Date & Time",
    "monitor.bottomBar.shortHistory.address": "Address",
    "monitor.bottomBar.shortHistory.vehicle": "Vehicle",
    "monitor.bottomBar.shortHistory.speed": "Speed (Km/Hr)",
    "monitor.bottomBar.shortHistory.orientation": "Orientation",
    "monitor.bottomBar.shortHistory.ignition": "Ignition",
    "monitor.bottomBar.actions.center": "Center on map",
    "monitor.bottomBar.actions.follow.start": "Follow vehicle",
    "monitor.bottomBar.actions.follow.stop": "Stop following",
    "monitor.bottomBar.shortHistory.close": "Close",
    "monitor.bottomBar.shortHistory.ignitionStateOn": "On",
    "monitor.bottomBar.shortHistory.ignitionStateOff": "Off",
    "monitor.bottomBar.shortHistory.noTimestamp": "Timestamp unavailable",
    "monitor.bottomBar.shortHistory.noAddress": "Address unavailable",
    "monitor.bottomBar.shortHistory.noSpeed": "N/A",
    "monitor.bottomBar.shortHistory.noVehicle": "N/A",
    "monitor.bottomBar.shortHistory.noOrientation": "N/A",
    "monitor.bottomBar.shortHistory.orientation.north": "North",
    "monitor.bottomBar.shortHistory.orientation.northeast": "North-East",
    "monitor.bottomBar.shortHistory.orientation.east": "East",
    "monitor.bottomBar.shortHistory.orientation.southeast": "South-East",
    "monitor.bottomBar.shortHistory.orientation.south": "South",
    "monitor.bottomBar.shortHistory.orientation.southwest": "South-West",
    "monitor.bottomBar.shortHistory.orientation.west": "West",
    "monitor.bottomBar.shortHistory.orientation.northwest": "North-West",
    "monitor.stats.title": "Fleet summary",
    "monitor.stats.subtitle": "Live status based on the latest reports.",
    "monitor.stats.total": "Total vehicles",
    "monitor.stats.moving": "Moving",
    "monitor.stats.halted": "Idling",
    "monitor.stats.stopped": "Stopped",
    "monitor.stats.withoutSignal": "Without signal (>{days} days)"
};
